var _excluded = ["className", "type", "children", "label", "isLoading", "isHidden", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import StyledOverlay from './overlay.styles';
import StyledOverlayContent from './styles/overlay.content.styles';
import Loader from '../loader';
import { StyledCacheWrapper } from '../../styles';
var overlayPropTypes = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Type mode: light or dark */
  type: PropTypes.oneOf(['dark', 'light']),
  /** Content inside Overlay */
  children: PropTypes.node,
  /** Loading label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** If overlay contains loading text and/or spinner */
  isLoading: PropTypes.bool,
  /** Whether to hide or reveal overlay */
  isHidden: PropTypes.bool,
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var overlayDefaultProps = {
  className: '',
  type: 'dark',
  children: null,
  label: 'Loading',
  isLoading: false,
  isHidden: true,
  utils: {}
};

// global count for overlays
var overlayCount = 0;

/**
 * @ignore @description
 * ## Overlay Component
 * The Overlay component is used to disable/hide elements behind content. Background options are default blue, dark or light.
 *
 * @ignore @see Mesh: [Overlay Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/containers-overlay--default)
 *
 * @ignore @example
 * ```jsx
 * import { Overlay } from 'mesh-component-library';
 *
 * <Overlay {...props} />
 * ```
 */

var Overlay = function Overlay(props) {
  var className = props.className,
    type = props.type,
    children = props.children,
    label = props.label,
    isLoading = props.isLoading,
    isHidden = props.isHidden,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  useEffect(function () {
    if (!isHidden) {
      overlayCount += 1;
      document.body.style.overflow = 'hidden';
    }
    return function () {
      if (!isHidden) {
        overlayCount -= 1;
        if (overlayCount === 0) {
          document.body.style.overflow = '';
        }
      }
    };
  }, [isHidden]);
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledOverlay, _extends({
    className: className,
    hidden: isHidden,
    role: "button",
    isLoading: isLoading,
    type: type,
    utils: utils
  }, other), isLoading && /*#__PURE__*/React.createElement(StyledOverlayContent, null, label, /*#__PURE__*/React.createElement(Loader, {
    size: "lg",
    variant: "inverse"
  })), children));
};
Overlay.propTypes = overlayPropTypes;
Overlay.defaultProps = overlayDefaultProps;
export default Overlay;